module.exports = __webpack_public_path__ + "img/pic_recruit_picture2.aa2c7da4.png";